import store from '@/store'
export default [
  {
    path: '/disciplinary-records',
    name: 'disciplinary-record',
    meta: { requiresAuth: true },
    component: () => import('@/pages/disciplinary-record/index.vue')
  },
  {
    path: '/disciplinary-records/:id',
    name: 'disciplinary-record-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/disciplinary-record/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      let response = await store.dispatch(
        'disciplinaryRecord/find',
        to.params.id
      )
      let { ...resource } = response.data
      to.params.editData = resource
      next()
    }
  }
]
